<template>
  <section class="page-product-products-recommended">
    <!-- Title -->
    <div class="row-1">
      <h2 class="title m-right-16px" v-anim-reveal-text>
        {{ $t('pages.product.recommendedTitle') }}
      </h2>
    </div>
    <div
      class="m-top-5 page-product-products-recommended__swiper"
      v-anim-parallax-element="{
        target: 'picture',
        offset: 10,
      }"
    >
      <WidgetSliderSwiper :slides="formattedProducts" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'PagesProductProductsRecommended',
}
</script>

<script setup>
const props = defineProps({
  products: Object,
})

const formattedProducts = computed(() => {
  return props.products.map((product) => ({
    title: product.title,
    cover: product.coverPortrait?.[0] || product.cover?.[0],
    route: {
      name: 'product-family-slug',
      params: { slug: product.slug },
    },
  }))
})
</script>

<style lang="scss">
@import './style.scss';
</style>
